import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const verificationAPI = {
  // Request verification for education
  requestEducationVerification: async (educationId) => {
    const response = await api.post(`/api/verification/education/${educationId}/request`);
    return response.data;
  },

  // Request verification for employment
  requestEmploymentVerification: async (employmentId) => {
    const response = await api.post(`/api/verification/employment/${employmentId}/request`);
    return response.data;
  },

  // Request verification for certification
  requestCertificationVerification: async (certificationId) => {
    const response = await api.post(`/api/verification/certification/${certificationId}/request`);
    return response.data;
  },

  // Get verification status
  getVerificationStatus: async (verificationId) => {
    const response = await api.get(`/api/verification/${verificationId}/status`);
    return response.data;
  },

  // Get all verification requests (for institutions)
  getVerificationRequests: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/api/verification/requests?${params}`);
    return response.data;
  },

  // Approve verification
  approveVerification: async (verificationId, data) => {
    const response = await api.post(`/api/verification/${verificationId}/approve`, data);
    return response.data;
  },

  // Reject verification
  rejectVerification: async (verificationId, data) => {
    const response = await api.post(`/api/verification/${verificationId}/reject`, data);
    return response.data;
  },

  // Delegate verification
  delegateVerification: async (verificationId, data) => {
    const response = await api.post(`/api/verification/${verificationId}/delegate`, data);
    return response.data;
  },

  // Request more info
  requestMoreInfo: async (verificationId, data) => {
    const response = await api.post(`/api/verification/${verificationId}/request-info`, data);
    return response.data;
  },

  // Accept disclaimer
  acceptDisclaimer: async (verificationId, data) => {
    const response = await api.post(`/api/verification/${verificationId}/disclaimer`, data);
    return response.data;
  },

  getActiveDisclaimer: async (type = 'EDUCATION') => {
  const response = await api.get(`/api/disclaimer/active/${type}`);
  return response.data;
},

// Dashboard APIs
  getDashboard: async () => {
    const response = await api.get('/api/dashboard');
    return response.data;
  },
  
  getDashboardSummary: async () => {
    const response = await api.get('/api/dashboard/summary');
    return response.data;
  },
  
  // Audit logs
  getAuditLogs: async (verificationId) => {
    const response = await api.get(`/api/audit-logs/verification/${verificationId}`);
    return response.data;
  },
  
  getAllAuditLogs: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/api/audit-logs?${params}`);
    return response.data;
  },
  
  // Master data
  getMasterData: async (category) => {
    const response = await api.get(`/api/master-data/${category}`);
    return response.data;
  },
  // Request verification for reference
  requestReferenceVerification: async (referenceId) => {
    const response = await api.post(`/api/verification/reference/${referenceId}/request`);
    return response.data;
  },

  // Resend reference invite
  resendReferenceInvite: async (referenceId) => {
    const response = await api.post(`/api/reference/${referenceId}/resend`);
    return response.data;
  }
};
